export const GENERATION_STATUS_TABS = [
  { value: 'all', label: 'All' },
  { value: 'new', label: 'New' },
  { value: 'face_generating', label: 'Face Generating' },
  { value: 'face_pending', label: 'Face Pending' },
  { value: 'trial', label: 'Trial' },
  { value: 'completed', label: 'Completed' },
  { value: 'pending', label: 'Pending' },
  { value: 'stuck', label: 'Stuck' },
  { value: 'help', label: 'Order Help' },
  { value: 'approved', label: 'Approved' },
  { value: 'out_for_printing', label: 'Out for Printing' },
  { value: 'printed', label: 'Printed' },
  { value: 'cancelled', label: 'Cancelled' }
];

export const getGenerationStatusTabLabel = (label, count) => (
  `${label} (${Number(count) || 0})`
);
